var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "remove-warning", on: { click: _vm.cancel } },
    [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            {
              staticClass: "notification-box col-12 col-md-3",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                }
              }
            },
            [
              _c("q-icon", {
                staticClass: "warning-icon",
                attrs: { name: "trial", width: "110px" }
              }),
              _vm._v(" "),
              _c("h5", [
                _vm._v(
                  "\n          " + _vm._s(_vm.$t(_vm.getLabel)) + "\n        "
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n          " + _vm._s(_vm.$t(_vm.getContent)) + "\n        "
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "warning-controll-buttons" },
                [
                  _c("input-button", {
                    staticClass: "m-1",
                    attrs: {
                      variant: "standardInput",
                      hollow: "",
                      smaller: "",
                      btnStyle: "nok-style",
                      inputPlaceholder: _vm.$t("Button.cancel")
                    },
                    on: { click: _vm.cancel }
                  }),
                  _vm._v(" "),
                  _c("input-button", {
                    staticClass: "m-1",
                    attrs: {
                      variant: "standardInput",
                      hollow: "",
                      smaller: "",
                      conformation: "",
                      btnStyle: "ok-style",
                      inputPlaceholder: _vm.$t("Button.remove")
                    },
                    on: { click: _vm.remove }
                  })
                ],
                1
              )
            ],
            1
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d5f26f78", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5f26f78","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/standard/notify/RemoveWarning.vue
// module id = null
// module chunks = 